<template>
  <div class="d-flex justify-content-center">
    <el-card style="width: 300px;">
      <div slot="header" class="clearfix">
        <span>智慧點餐接單介面 - 登入</span>
      </div>
      <!-- FORM -->
      <el-form ref="qcpos-login-form" :rules="rules" :model="form">
        <el-form-item label="使用者帳號" prop="username">
          <el-input type="text" v-model="form.username" placeholder="請輸入帳號"></el-input>
        </el-form-item>
        <el-form-item label="密碼" prop="password">
          <el-input type="password" v-model="form.password" placeholder="請輸入密碼"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" round @click="submit"
            :disabled="form.submitting">登入</el-button>
        </el-form-item>
      </el-form>

      <!-- <br>
      <el-button type="text" @click="installPwa">更方便使用！安裝桌面Web App</el-button> -->
    </el-card>
  </div>
</template>

<script>
import axios from 'axios';
import { auth } from '../../firestore';

export default {
  components: {
  },

  mounted() {
  },

  methods: {
    submit() {
      this.form.submitting = true;
      this.$refs['qcpos-login-form'].validate(valid => {
        console.log(valid)
        if (!valid) {
          this.$message.error(`登入資料不正確！`);
          this.form.submitting = false;
          return;
        }
        this.signin();
      });
    },

    signin() {
      // console.log('signin', this.form);
      this.$store.dispatch('qcposLogin', {
        username: this.form.username, password: this.form.password
      })
      .then(ret => {
        console.info(`QCPOS: signin succeeded`, ret);

        //TODO: Proceed to QC-POS page.
        this.$router.push('/qcpos/pos');
        // setTimeout(() => {
        //   this.$router.push('/qcpos/pos');
        // }, 100);
      })
      .catch(err => {
        this.form.submitting = false;
        this.$message.error(`無法登入！請檢查登入資訊是否正確？`);
      });
    },

    installPwa() {
      if (window.evtInstallPwa) {
        window.evtInstallPwa.prompt();
        window.evtInstallPwa.userChoice.then(choiceResult => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt!');
          }
          else {
            console.log('User dismissed the A2HS prompt.');
          }
        });
      }
      else {
        alert('裝置不支援。請聯繫您的技術廠商。');
      }
    }
  },

  data() {
    return {
      form: {
        username: '', password: '',
        submitting: false
      },

      rules: {
        username: [
          { required: true, message: '請輸入帳號！', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '請輸入密碼！', trigger: 'blur' }
        ]
      }
    }
  }
}
</script>

<style scoped>
.el-button {
  width: 100%;
}
</style>